export default {
  namespaced: true,
  state: () => ({
    familiasTarifas: [],
    subcategorias: [],
    mercadosReserva: [],
    loading: false,
  }),
  getters: {
    getFamiliasTarifas(state) {
      return state.familiasTarifas;
    },
    familiasTarifas(state) {
      return state.familiasTarifas;
    },
    isLoadingFamilias(state) {
      return state.loading;
    },
    getSubcategorias(state) {
      return state.subcategorias;
    },
    getMercadosReserva(state) {
      return state.mercadosReserva;
    },
    mercadosReserva(state) {
      return state.mercadosReserva;
    },
    isLoadingMercados(state) {
      return state.loading;
    },
  },
  mutations: {
    setFamiliasTarifas(state, data) {
      state.familiasTarifas = data;
    },
    setLoading(state, status) {
      state.loading = status;
    },
    setSubcategorias(state, data) {
      state.subcategorias = data;
    },
    setMercadosReserva(state, data) {
      state.mercadosReserva = data;
    },
  },
  actions: {
    async getFamiliasTarifas({ commit, rootGetters }) {
      commit("setLoading", true);
      try {
        const database = rootGetters.getFirebaseApp.database;
        const snapshot = await database.queryBuilder("/RVA/FamiliasTarifarios");
        if (snapshot && snapshot.exists()) {
          const val = snapshot.val() || {};
          const familias = Object.entries(val)
            .filter(([, familia]) => !familia.Dlat)
            .map(([id, familia]) => ({ id, ...familia }));
          commit("setFamiliasTarifas", familias);
          return familias;
        } else {
          commit("setFamiliasTarifas", []);
          return [];
        }
      } catch (error) {
        console.error("Error al obtener FamiliasTarifarios:", error);
        commit("setFamiliasTarifas", []);
        throw error;
      } finally {
        commit("setLoading", false);
      }
    },
    async getSubcategoria({ commit, rootGetters }, MainDepartamento) {
      console.log(MainDepartamento);
      commit("setLoading", true);
      try {
        const database = rootGetters.getFirebaseApp.database;
        const data = await database.queryBuilder(
          "RVA/Tarifas/" + MainDepartamento + "/SubCategorias"
        );
        if (data && data.exists()) {
          const val = data.val() || {};
          const arrayHoteles = Object.entries(val);

          const subcategorias = arrayHoteles.map((element) => ({
            id: element[0],
            key: element[0],
            text: element[1].Nombre,
            value: element[0],
            ...element[1],
          }));

          commit("setSubcategorias", subcategorias);
          return subcategorias;
        } else {
          commit("setSubcategorias", []);
          return false;
        }
      } catch (error) {
        console.error("Error al obtener Subcategorias:", error);
        commit("setSubcategorias", []);
        throw error;
      } finally {
        commit("setLoading", false);
      }
    },
    async getMercadosReserva({ commit, rootGetters }) {
      commit("setLoading", true);
      try {
        const database = rootGetters.getFirebaseApp.database;
        const snapshot = await database.queryBuilder("/RVA/MercadosReserva");
        if (snapshot && snapshot.exists()) {
          const val = snapshot.val() || {};
          const mercados = Object.entries(val)
            .filter(([, mercado]) => !mercado.Dlat)
            .map(([id, mercado]) => ({
              id,
              ...mercado,
              nm: mercado.nm || mercado.Nombre || mercado.nombre || id,
              nombre: mercado.nombre || mercado.Nombre || mercado.nm || id,
              activo:
                mercado.activo !== undefined
                  ? mercado.activo
                  : mercado.Activo !== undefined
                    ? mercado.Activo
                    : true,
            }));
          commit("setMercadosReserva", mercados);
          return mercados;
        } else {
          commit("setMercadosReserva", []);
          return [];
        }
      } catch (error) {
        console.error("Error al obtener MercadosReserva:", error);
        commit("setMercadosReserva", []);
        throw error;
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
